import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { ScopeSchemaChangesRoute } from '../../routing'

export  class ScopeSchemaChangesPage extends Component {
    render() {
        return (
            <Fragment>
            <Breadcrumbs />
            <ScopeSchemaChangesRoute />
          </Fragment>
        )
    }
}
